import Reveal from "@/components/Reveal";

const fragments = [
  {
    image: "/artworks/through-the-blue.jpg",
    alt: "Through The Blue",
    align: "left",
    text: "He painted alone for thirty years.",
    pos: "md:col-start-7 md:col-span-6",
  },
  {
    image: "/artworks/reflected-grace.jpg",
    alt: "Reflected Grace",
    align: "right",
    text: "The canvas became the only place he could be fully himself.",
    pos: "md:col-start-1 md:col-span-6",
  },
  {
    image: "/artworks/the-dome.jpg",
    alt: "The Dome",
    align: "left",
    text: "Cosmic truths, rendered in household paint.",
    pos: "md:col-start-7 md:col-span-6",
  },
  {
    image: "/artworks/light-language.jpg",
    alt: "Light Language",
    align: "right",
    text: "A body of work, coming into the light for the first time.",
    pos: "md:col-start-1 md:col-span-6",
  },
];

const Immersion = () => {
  return (
    <section
      id="immersion"
      data-testid="immersion-section"
      className="bone-section relative"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-32 md:pt-48 pb-24 md:pb-40">
        <Reveal className="max-w-xl">
          <p className="hairline mb-6" data-testid="immersion-intro-label">
            I. The Work
          </p>
          <h2 className="font-serif italic text-4xl md:text-5xl leading-[1.05] mb-10">
            Before a word, a painting.
          </h2>
        </Reveal>

        <div className="space-y-32 md:space-y-48 mt-16 md:mt-24">
          {fragments.map((frag, i) => (
            <div
              key={frag.alt}
              className="grid grid-cols-12 gap-6 md:gap-12 items-center"
            >
              <Reveal
                className={`col-span-12 ${
                  frag.align === "left"
                    ? "md:col-start-1 md:col-span-7"
                    : "md:col-start-6 md:col-span-7"
                }`}
                slow
              >
                <figure className="relative">
                  <img
                    src={frag.image}
                    alt={frag.alt}
                    className="w-full h-auto block"
                    loading="lazy"
                    data-testid={`immersion-artwork-${i}`}
                  />
                  <figcaption className="hairline mt-4 opacity-60">
                    {frag.alt}
                  </figcaption>
                </figure>
              </Reveal>

              <Reveal
                className={`col-span-12 ${frag.pos} md:pt-0`}
                delay={250}
              >
                <p
                  className="font-serif italic text-2xl md:text-3xl leading-[1.25] text-[color:var(--ink)]"
                  data-testid={`immersion-fragment-${i}`}
                >
                  {frag.text}
                </p>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Immersion;
